import { lazy } from "react";

import { RoutePathBuilder } from "@/common/builders/routePath";
import AuthorizedRoute from "@/common/components/Auth/AuthorizedRoute";
import { Loadable } from "@/common/components/Loadable";
import { ROUTE_PATH } from "@/common/constants/routing";
import { AppPermission } from "@/core/api/generated/v1";

const VehicleActualStatePage = Loadable(
  lazy(() => import("../../MainAppView/VehicleActualState/VehicleActualStatePage")),
);
const VehicleDamageViewPage = Loadable(
  lazy(() => import("../../MainAppView/VehicleDamages/VehicleDamageViewPage")),
);
const VehicleDamagesPage = Loadable(
  lazy(() => import("../../MainAppView/VehicleDamages/VehicleDamagesPage")),
);
const VehicleHistoryPage = Loadable(
  lazy(() => import("../../MainAppView/VehicleHistory/VehicleHistoryPage")),
);
const VehicleCreateManySimilarPage = Loadable(
  lazy(() => import("../../MainAppView/Vehicles/VehicleCreateManySimilarPage")),
);
const VehicleCreateUpdatePage = Loadable(
  lazy(() => import("../../MainAppView/Vehicles/VehicleCreateUpdatePage")),
);
const VehicleViewPage = Loadable(lazy(() => import("../../MainAppView/Vehicles/VehicleViewPage")));

export function VehicleRoutes() {
  return (
    <>
      {/* Vehicle */}
      <AuthorizedRoute
        permissions={[AppPermission.FleetAppAccess, AppPermission.VehicleRead]}
        exact
        path={RoutePathBuilder.toDefinition(ROUTE_PATH.VEHICLE_VIEW())}
        render={() => <VehicleViewPage />}
      />
      <AuthorizedRoute
        permissions={[AppPermission.FleetAppAccess, AppPermission.VehicleManage]}
        exact
        path={RoutePathBuilder.toDefinition(ROUTE_PATH.VEHICLE_CREATE)}
        render={() => <VehicleCreateUpdatePage />}
      />
      <AuthorizedRoute
        permissions={[AppPermission.FleetAppAccess, AppPermission.VehicleManage]}
        exact
        path={RoutePathBuilder.toDefinition(ROUTE_PATH.VEHICLE_CREATE_MANY_SIMILAR)}
        render={() => <VehicleCreateManySimilarPage />}
      />
      <AuthorizedRoute
        permissions={[AppPermission.FleetAppAccess, AppPermission.VehicleManage]}
        exact
        path={RoutePathBuilder.toDefinition(ROUTE_PATH.VEHICLE_EDIT())}
        render={() => <VehicleCreateUpdatePage />}
      />
      <AuthorizedRoute
        permissions={[AppPermission.FleetAppAccess, AppPermission.VehicleRead]}
        exact
        path={RoutePathBuilder.toDefinition(ROUTE_PATH.VEHICLE_HISTORY())}
        render={() => <VehicleHistoryPage />}
      />
      <AuthorizedRoute
        permissions={[AppPermission.FleetAppAccess, AppPermission.VehicleRead]}
        exact
        path={RoutePathBuilder.toDefinition(ROUTE_PATH.VEHICLE_ACTUAL_STATE())}
        render={() => <VehicleActualStatePage />}
      />

      {/* VehicleDamage */}
      <AuthorizedRoute
        permissions={[AppPermission.VehicleDamageRead, AppPermission.FleetAppAccess]}
        exact
        path={RoutePathBuilder.toDefinition(ROUTE_PATH.VEHICLE_DAMAGE_VIEW())}
        render={() => <VehicleDamageViewPage />}
      />
      <AuthorizedRoute
        permissions={[AppPermission.VehicleDamageRead, AppPermission.FleetAppAccess]}
        exact
        path={RoutePathBuilder.toDefinition(ROUTE_PATH.VEHICLE_DAMAGE_VIEW_ALT())}
        render={() => <VehicleDamageViewPage />}
      />
      <AuthorizedRoute
        permissions={[AppPermission.VehicleDamageRead, AppPermission.FleetAppAccess]}
        exact
        path={RoutePathBuilder.toDefinition(ROUTE_PATH.VEHICLES_DAMAGES())}
        render={() => <VehicleDamagesPage />}
      />
      <AuthorizedRoute
        permissions={[AppPermission.VehicleDamageRead, AppPermission.FleetAppAccess]}
        exact
        path={RoutePathBuilder.toDefinition(ROUTE_PATH.VEHICLE_DAMAGES())}
        render={() => <VehicleDamagesPage />}
      />
    </>
  );
}
